import { Menu as MMenu } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { FORTA_BLUE } from '../../utils/colors';

import type { MenuProps } from '@mui/material';

const useStyles = makeStyles({
  root: {
    marginTop: '2em',

    '& .MuiPaper-root': {
      boxShadow: 'none',
      padding: '30px 15px 15px 15px',
      marginTop: -10,
      marginLeft: 37,
      backgroundColor: 'transparent',

      '&::before': {
        content: "''",
        position: 'absolute',
        top: 6,
        right: 40,
        borderColor: 'transparent',
        borderBottom: `15px solid ${FORTA_BLUE.light3}`,
        borderTop: '15px solid transparent',
        borderLeft: '15px solid transparent',
        borderRight: '15px solid transparent',
        zIndex: 100,
      },
    },

    '& .MuiList-root': {
      backgroundColor: FORTA_BLUE.light3,
      padding: '0.5em 0',
      borderRadius: '10px',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },

    '& .MuiMenuItem-root': {
      padding: '0 1em',

      '&::after': {
        content: '',
        width: '100%',
        height: '1px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      },
    },
  },
});

function FMenu(props: MenuProps) {
  const { id, open, anchorEl, onClose, children } = props;
  const classes = useStyles();

  return (
    <MMenu
      {...props}
      className={classes.root}
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {children}
    </MMenu>
  );
}

export default FMenu;
